//--------- IMPORTAÇÕES --------//
import { useEffect, useContext } from "react"; // Importação de Hooks
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { Main } from "./components";
import { TagsContext } from "./context/TagsContext";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { loadTagsService } from "./services";



//--------- EXPORTAÇÃO DA FUNÇÃO TAGS VISUAL ---------//
export default function Tags() {



    //---------- CRIAÇÃO DOS HOOKS ---------//
    const { tags, setTags } = useContext(TagsContext); // Estado que armazena a lista de Tags
    const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



    //--------- USE EFFECT INICIAL ---------//
    useEffect(() => {
        setIsLoading(true);
        handleLoadTags(); // Carrega as Tags na página
        setIsLoading(false);
    }, []);



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
    // Nesta função, é requisitado à API as TAGS armazenadas.
    // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
    async function handleLoadTags() {
        const response = await loadTagsService();
        if(response){
            setTags(response.data);
        }
    };



    //-------- RETORNO CONDICIONAL DA PÁGINA TAGS PAGE ----------//
    return (
        <>
            {isLoading ? <Loading /> : <Main />}
        </>
    )
}